import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { SidebarToggleRequested } from '../base/home/store/acceso/acceso.actions';
import { accesoSidebarCollapsed } from '../base/home/store/acceso/acceso.selectors';
import { AppState } from '../reducers';
import { showSidebarAnimation } from './sidebar.animations';

@Component({
	selector: 'sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	animations: [ showSidebarAnimation ]
})
export class SidebarComponent implements AfterViewInit {

	isCollapsed$: Observable<boolean>;

	@ViewChild( "content", { static: false } )
	content: ElementRef;


	constructor( private store: Store<AppState> ) {
		this.isCollapsed$ = this.store.select( accesoSidebarCollapsed );
	}

	ngAfterViewInit(): void {
		// this.store.select( accesoSidebarCollapsed ).pipe(
		// 	tap( collapsed => {
		// 		if( collapsed )
		// 			setTimeout( () => { this.content.nativeElement.scrollTop() }, 0 );
		// 	})
		// ).subscribe();
	}

	onSidebarClosed() {
		this.store.dispatch( new SidebarToggleRequested() );
	}

	onAccessSelected() {
		this.store.dispatch( new SidebarToggleRequested() );
	}

}
